/**
 * Format string placeholders without reprocessing inserted values.
 * Numbered placeholders allow translators to reorder arguments; sequential
 * %s placeholders remain supported for existing translations and labels.
 */
export default ( template, ...values ) => {
    let next = 0;
    return template.replace( /%%|%(?:(\d+)\$)?s/g, ( placeholder, position ) => {
        if ( placeholder === "%%" ) return "%";
        const index = position === undefined ? next++ : Number( position ) - 1;
        return index >= 0 && index < values.length ? String( values[index] ) : placeholder;
    } );
};
